export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1771909715670-083a55b7f354?crop=entropy&cs=srgb&fm=jpg&q=85",
  karate: "https://images.unsplash.com/photo-1555597673-b21d5c935865?q=80&w=1600&auto=format&fit=crop",
  judo: "https://images.unsplash.com/photo-1783203871191-170195c9aa10?q=80&w=1600&auto=format&fit=crop",
  bjj: "https://images.unsplash.com/photo-1542937306-0a804f0ad7b7?q=80&w=1600&auto=format&fit=crop",
  taekwondo: "https://images.pexels.com/photos/30858416/pexels-photo-30858416.jpeg?auto=compress&cs=tinysrgb&w=1600",
  muaythai: "https://images.unsplash.com/photo-1525680996651-0222228be6f0?q=80&w=1600&auto=format&fit=crop",
  athlete: "https://images.unsplash.com/photo-1602827114685-efbb2717da9f?q=80&w=1600&auto=format&fit=crop",
  spectator: "https://images.unsplash.com/photo-1611824916163-a984d622d042?q=80&w=1600&auto=format&fit=crop",
  aotearoa: "https://images.pexels.com/photos/696680/pexels-photo-696680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/disciplines", label: "Martial Arts" },
  { to: "/event", label: "Event" },
  { to: "/schedule", label: "Schedule" },
  { to: "/federations", label: "Federations" },
  { to: "/athletes", label: "Athletes" },
  { to: "/results", label: "Results" },
  { to: "/news", label: "News" },
  { to: "/partners", label: "Partners" },
  { to: "/contact", label: "Contact" },
];

export const DISCIPLINES = [
  {
    slug: "karate",
    name: "Karate",
    origin: "Japan",
    family: "Striking",
    tag: "The way of the empty hand",
    image: "karate",
    blurb:
      "One of the world's most practised martial arts — precision striking, kata and kumite forged through decades of tradition.",
    detail:
      "Karate blends explosive striking with deep ceremonial tradition. At Kumite Games, karate competition — kata and kumite — will be delivered under the technical authority of its participating organisation, honouring the styles and standards of the art.",
  },
  {
    slug: "judo",
    name: "Judo",
    origin: "Japan",
    family: "Grappling",
    tag: "The gentle way",
    image: "judo",
    blurb:
      "Throws, holds and the art of maximum efficiency. A discipline of balance, timing and respect bowed in on the tatami.",
    detail:
      "Judo's contest of grips, throws and groundwork is one of the great spectator martial arts. Competition at Kumite Games will follow the rules, officiating and division structures set by judo's participating organisation.",
  },
  {
    slug: "brazilian-jiu-jitsu",
    name: "Brazilian Jiu-Jitsu",
    origin: "Brazil",
    family: "Grappling",
    tag: "The art of control",
    image: "bjj",
    blurb:
      "Ground fighting refined to a science — leverage, position and submission in one of the fastest-growing arts on earth.",
    detail:
      "Brazilian Jiu-Jitsu rewards strategy and technique over size and strength. Its Kumite Games competition will be run to the standards of its participating organisation, across gi and — where confirmed — no-gi divisions.",
  },
  {
    slug: "taekwondo",
    name: "Taekwondo",
    origin: "Korea",
    family: "Striking",
    tag: "The way of foot and fist",
    image: "taekwondo",
    blurb:
      "Spectacular high-speed kicking and Olympic pedigree — an art of explosive athleticism and precise control.",
    detail:
      "Taekwondo brings speed, height and spectacle to the mats. Kyorugi and poomsae competition at Kumite Games will be governed by the art's participating organisation and its technical officials.",
  },
  {
    slug: "muay-thai",
    name: "Muay Thai",
    origin: "Thailand",
    family: "Striking",
    tag: "The art of eight limbs",
    image: "muaythai",
    blurb:
      "Punches, kicks, elbows and knees — Thailand's national art, steeped in ritual, music and warrior culture.",
    detail:
      "Muay Thai's wai kru ritual and eight-limb arsenal make it one of the most compelling combat spectacles in the world. Its Kumite Games presentation will respect the art's traditions and its participating organisation's standards.",
  },
];

export const ARENAS = [
  {
    name: "Tatami Areas",
    text: "Traditional matted competition fields honouring the etiquette and ceremony of the Japanese and Korean arts.",
  },
  {
    name: "Combat Arenas",
    text: "Dedicated grappling and contest zones engineered for intensity, safety and clear sightlines.",
  },
  {
    name: "Competition Rings",
    text: "Raised rings under arena lighting — the classic stage for Muay Thai and the ring arts.",
  },
  {
    name: "Competition Mats",
    text: "Multiple simultaneous competition surfaces so the festival never stops moving.",
  },
];

export const NEWS_ITEMS = [
  {
    slug: "event-announcement",
    tag: "Announcement",
    title: "Kumite Games — Event Announcement",
    image: "hero",
  },
  {
    slug: "new-martial-art-confirmed",
    tag: "Disciplines",
    title: "New Martial Art Confirmed",
    image: "taekwondo",
  },
  {
    slug: "federation-partnership",
    tag: "Federations",
    title: "Federation Partnership",
    image: "judo",
  },
  {
    slug: "venue-announcement",
    tag: "Event",
    title: "Venue Announcement",
    image: "aotearoa",
  },
  {
    slug: "athlete-information",
    tag: "Athletes",
    title: "Athlete Information",
    image: "athlete",
  },
];

export const PARTNER_TIERS = [
  { name: "Major Partners", slots: 3 },
  { name: "Event Partners", slots: 4 },
  { name: "Participating Organisations", slots: 4 },
  { name: "Suppliers", slots: 4 },
  { name: "Community Partners", slots: 4 },
];

export const CONTACT_REASONS = [
  "General Enquiry",
  "Martial Arts Organisation",
  "Federation Partnership",
  "Athlete Enquiry",
  "Sponsorship",
  "Media",
  "Vendor",
  "Volunteer",
  "Other",
];

export const EVENT_INFO = [
  { label: "Venue", value: "Coming Soon" },
  { label: "Event Date", value: "Coming Soon" },
  { label: "Doors Open", value: "Coming Soon" },
  { label: "Competition Times", value: "Coming Soon" },
  { label: "Parking", value: "Coming Soon" },
  { label: "Accommodation", value: "Coming Soon" },
  { label: "Spectator Information", value: "Coming Soon" },
  { label: "Food & Vendors", value: "Coming Soon" },
  { label: "Accessibility", value: "Coming Soon" },
  { label: "Health & Safety", value: "Coming Soon" },
];

export const FAQS = [
  {
    q: "When will Kumite Games take place?",
    a: "The official event date will be announced soon. Follow our news page and social channels for the announcement.",
  },
  {
    q: "Where will the event be held?",
    a: "Kumite Games will be hosted in New Zealand. The venue and city will be confirmed and announced in due course.",
  },
  {
    q: "Which martial arts are included?",
    a: "The first edition features Karate, Judo, Brazilian Jiu-Jitsu, Taekwondo and Muay Thai. Additional martial arts may be added in future editions as new organisations come on board.",
  },
  {
    q: "Who runs the competition for each martial art?",
    a: "Each participating organisation retains full technical authority over its own discipline — including competition rules, officiating standards and sport-specific requirements. Kumite Games provides the event platform, venue experience and promotion.",
  },
  {
    q: "When can athletes register?",
    a: "Athlete registration is not open yet. Registration details will be published ahead of the event — check the Register page for updates.",
  },
];
